"use client";

import { useLayoutEffect } from "react";
import { usePathname } from "next/navigation";

/**
 * Client navigations (e.g. from the homepage news carousel) can finish with a
 * stale scroll position. Snap to the top of the page before paint.
 */
export function NewsArticleEnterScroll() {
  const pathname = usePathname();

  useLayoutEffect(() => {
    const run = () => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    };

    run();
    const id = requestAnimationFrame(() => requestAnimationFrame(run));
    return () => cancelAnimationFrame(id);
  }, [pathname]);

  return null;
}
